import { z } from 'zod';
import { TenantIdSchema, MoneySchema } from './_primitives.js';

export const ITEM_TYPE = Object.freeze({
  PRODUCT:   'product',
  ACCESSORIAL: 'accessorial',
  FUEL:      'fuel',
  SERVICE:   'service',
});

export const ItemTypeEnum = z.enum(Object.values(ITEM_TYPE));

export const ItemSchema = z.object({
  tenantId:    TenantIdSchema,
  id:          z.string().optional(),
  sku:         z.string().optional(),
  name:        z.string().min(1),
  description: z.string().optional(),
  type:        ItemTypeEnum.optional(),
  unitCost:    MoneySchema.optional(),
  unitPrice:   MoneySchema.optional(),
  weight:      z.number().nonnegative().optional(),
  dimensions: z.object({
    length: z.number().nonnegative().optional(),
    width:  z.number().nonnegative().optional(),
    height: z.number().nonnegative().optional(),
    unit:   z.string().optional(),
  }).optional(),
  hazmat:      z.boolean().optional(),
  unNumber:    z.string().optional(),
  isDeleted:   z.boolean().optional(),
  createdAt:   z.union([z.string(), z.object({})]).optional(),
  updatedAt:   z.union([z.string(), z.object({})]).optional(),
  version:     z.number().int().optional(),
}).passthrough();

/** @typedef {import('zod').infer<typeof ItemSchema>} Item */
